import styled from 'styled-components';
import { BEHAVIOR } from 'components/twilio/constants';

const ChatTitleButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-basis: ${BEHAVIOR.MAX_TITLE_BUTTONS * BEHAVIOR.TITLE_BUTTON_WIDTH}px;
`;

export default ChatTitleButtonGroup;
